import AboutLiz from "@/components/AboutLiz";
import Testimonials from "@/components/Testimonials";
import CtaBanner from "@/components/CtaBanner";
import { motion } from "framer-motion";

const values = [
  { title: "Warm & human", body: "Learning happens through connection. Every session prioritises safety, real conversation and shared experience." },
  { title: "Evidence based", body: "Content is drawn from MHFA England's rigorously researched curriculum — the UK's most trusted MHFA framework." },
  { title: "Practical, not preachy", body: "We focus on the language, tools and confidence people actually use back at their desks — not just theory." },
  { title: "Ongoing, not one-off", body: "Wellbeing is a culture, not an event. Our packages support your MHFAiders long after the certificate lands." },
];

export default function About() {
  return (
    <div data-testid="about-page" className="pt-36">
      <div className="container-x">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <p className="eyebrow mb-4">About Rise Learning</p>
          <h1 className="font-serif-display text-5xl md:text-7xl leading-[1.02] tracking-tight text-[#1E2A25] max-w-4xl">
            A dedicated practice with <span className="italic text-[#4A5D52]">a big commitment</span> to workplace wellbeing.
          </h1>
        </motion.div>
      </div>

      <AboutLiz compact />

      <section data-testid="values-section" className="section bg-[#F3EFEA]">
        <div className="container-x">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-14">
            <div className="md:col-span-6">
              <p className="eyebrow mb-4">How we work</p>
              <h2 className="font-serif-display text-4xl md:text-5xl text-[#1E2A25] leading-tight">Four beliefs that shape every session.</h2>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {values.map((v, i) => (
              <motion.div
                key={i}
                data-testid={`value-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="bg-[#FDFBF7] rounded-3xl p-8 border border-[#8DA399]/25"
              >
                <div className="font-serif-display text-6xl text-[#D88C76]/40 leading-none">0{i + 1}</div>
                <h3 className="font-serif-display text-2xl mt-4 text-[#1E2A25]">{v.title}</h3>
                <p className="mt-3 text-[#4A5D52] leading-relaxed">{v.body}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Testimonials />
      <CtaBanner />
    </div>
  );
}
